import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux';
import { changeStateAuthFranRequest, getFranchiseAuthRequestByID } from '../../actions/certificationActions';
import { EcoStoreIcon } from '../../../assets/icons';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG';

const CertificateFranchiseAuthRequest = ({ match, history }) => {
    let idAuthRequest = match.params.idAuthRequest

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getFranchiseAuthRequestByID(idAuthRequest))
    }, [])

    const { franchiseRequest } = useSelector((state) => state.certificationAdmin);

    const [argument, setargument] = useState('')

    return (
        <div>
            <TitleSVG Icon={EcoStoreIcon}
                titleHighlight={'Datos'}
                title={' de la solicitud'}
            />
            <div className='wrapper-1 column-gap row-gap mt-5'>
                {franchiseRequest &&

                    <div className="card-admin">
                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Nombre: </span>
                            {franchiseRequest?.userID?.name}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Apellido: </span>
                            {franchiseRequest?.userID?.lastname}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Razon social: </span>
                            {franchiseRequest?.socialReason}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Razon de ser EcoTienda: </span>
                            {franchiseRequest?.reasonForRequest}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Tipo de persona: </span>
                            {franchiseRequest?.kindOfPerson}
                        </div>


                        {(franchiseRequest?.kindOfPerson === "juridica" || franchiseRequest?.kindOfPerson === "comerciante") &&
                            <>
                                <div className="text-content-card mt-1">
                                    <span className='text-bold color-purple-dark'>
                                        Rut:
                                    </span>
                                    <a target="_blank" href={franchiseRequest?.rut?.url?.origin}>Ver soporte</a>
                                </div>

                                <div className="text-content-card mt-1">
                                    <span className='text-bold color-purple-dark'>
                                        Cámara de comercio:
                                    </span>
                                    <a target="_blank" href={franchiseRequest?.chamberOfCommerce?.url?.origin}>Ver soporte</a>
                                </div>

                                <div className="text-content-card mt-1">
                                    <span className='text-bold color-purple-dark'>
                                        Certificación bancaria:
                                    </span>
                                    <a target="_blank" href={franchiseRequest?.bankCertification?.url?.origin}>Ver soporte</a>
                                </div>

                                {franchiseRequest.commercialReference &&
                                    <div className="text-content-card mt-1">
                                        <span className='text-bold color-purple-dark'>
                                            Referencia comercial:
                                        </span>
                                        <a target="_blank" href={franchiseRequest?.commercialReference?.url?.origin}>Ver soporte</a>
                                    </div>

                                }
                            </>
                        }
                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'> Ubicación: </span>
                            {franchiseRequest?.ubication?.businessCity},
                            {franchiseRequest?.ubication?.businessDepartment},
                            {franchiseRequest?.ubication?.businessCountry},
                        </div>

                        <div className='mt-2'>
                            -
                        </div>

                        <div className='text-bold color-purple-dark mt-2'>Motivo de rechazo</div>
                        <input
                            className='height-100 rounded border-box border-light border-secondary-color mt-1'
                            type="text"
                            id="argument"
                            name="argument"
                            value={argument}
                            onChange={(e) => { setargument(e.target.value) }}
                        />

                        <div className="column centerContent">
                            <div className="btns-admin ml-1 mr-1"
                                onClick={() => { dispatch(changeStateAuthFranRequest(franchiseRequest._id, 2, history)) }}>Aceptar</div>
                            <div className="btn-red btns-admin ml-1"
                                onClick={() => { dispatch(changeStateAuthFranRequest(franchiseRequest._id, 1, history, argument)) }}>Rechazar</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CertificateFranchiseAuthRequest
